export default Object.freeze({
  POLICY_HOLDER: 'M',
  NON_POLICY_HOLDER: 'P',
});
